import React from "react";
import * as DocUtils from "../../../utils/Docs/DocUtils";
import { Tooltip } from "antd";

export const ParagraphList = ({ paragraphList, beforeFirst, afterLast }) => {
    return (
        <div className={DocUtils.setRtlClass("doc-container")}>
            {paragraphList.map((paragraph, idx) => (
                <p key={idx}>
                    {idx === 0 && beforeFirst}
                    <Paragraph paragraph={paragraph} />
                    {idx === paragraphList.length - 1 && afterLast}
                </p>
            ))}
        </div>
    );
};

const Paragraph = ({ paragraph }) => {
    return (
        <React.Fragment>
            {paragraph.map(([type, matchText, sentiment], index) => (
                <span
                    key={index}
                    className={`doc-text__match doc-text__match--${type} doc-text__match-${sentiment}`}
                >
                    {type === "text" ? (
                        matchText
                    ) : (
                        <Tooltip
                            title={`${type === "exact" ? "This concept exactly matches your search" : "This concept is related to your search"}`}
                            placement="top"
                        >
                            <span>{matchText}</span>
                        </Tooltip>
                    )}
                </span>
            ))}
        </React.Fragment>
    );
};
